import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
 

export const useStyles = makeStyles((theme) => ({

    customToolTip: {
        backgroundColor:alpha(theme.palette.secondary.main,.4),

        // backgroundColor:alpha(theme.palette.background.main,.4),
        padding:theme.spacing(2)
    }
  
}));
